import React, { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  initialValues,
  validationSchema,
} from "../../componentes/SeleccionarLocalidad";
import "../../scss/index.scss";
import imaLogo from "../../imagenes/logo.png";
import imaLocalidad from "../../imagenes/Localidad.png";
import { Grid, Header, Image, Form } from "semantic-ui-react";
import {
  selecciona_localidad,
  seleccionar_localidad,
  continuar,
} from "../../utils/traductor";
import { apiLocalidad } from "../../api/localidad";
import { estiloBotones } from "../../estilos";
import { ENTORNO } from "../../utils/constantes";
import { setLocalidad, getLocalidad } from "../../utils/variablesLocales";

const apilocalidad = new apiLocalidad();

export function SeleccionarLocalidad() {
  const navigate = useNavigate();

  const navigateToIngresar = () => {
    navigate(ENTORNO.URL_APLICACION + "/Ingresar");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        navigateToIngresar();
      } catch (error) {
        console.log(error);
      }
    },
  });

  ////////////////////////////////

  const [localidads, setLocalidad1] =
    useState(
      null
    ); /*esta variable localidads, maneja el estado del item seleccionado en el combo localidad*/

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //obtengo la lista de localidads para luego cargar el combo
        const response = await apilocalidad.obtener();
        setLocalidad1(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, []);

  ////////////////////////////////

  var localidadRegistros = [];

  if (localidads) {
    for (let i = 0; i < localidads.length; i++) {
      localidadRegistros.push({
        key: localidads[i].Nombre,
        text: localidads[i].Nombre,
        value: localidads[i].Nombre,
      });
    }
  }
  ////////////////////////////////

  return (
    <div className="ingresar">
      <Grid textalign="center" container style={{ padding: "10em 0em" }}>
        <Grid.Row>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Form onSubmit={formik.handleSubmit}>
              <Image src={imaLogo} className="logoCrearCuenta" centered />
              <br></br>
              <LazyLoadImage
                src={imaLocalidad}
                className="Localidad"
                effect="blur"
              />
              <br></br>
              <Header as="h3">{seleccionar_localidad}</Header>
              <Form.Field>
                <Form.Dropdown
                  name="localidad"
                  value={getLocalidad()}
                  onChange={(_, data) => {
                    formik.setFieldValue("localidad", data.value);
                    setLocalidad(data.value);
                  }}
                  error={formik.errors.localidad}
                  placeholder={selecciona_localidad}
                  fluid
                  selection
                  // options={localidadRegistros}

                  options={[
                    {
                      key: "El Calafate",
                      text: "El Calafate",
                      value: "El Calafate",
                    },
                    {
                      key: "Valencia",
                      text: "Valencia",
                      value: "Valencia",
                    },
                    {
                      key: "Córdoba",
                      text: "Córdoba",
                      value: "Córdoba",
                    },
                    {
                      key: "Ushuaia",
                      text: "Ushuaia",
                      value: "Ushuaia",
                    },
                    {
                      key: "Santiago del Estero",
                      text: "Santiago del Estero",
                      value: "Santiago del Estero",
                    },
                    {
                      key: "Colonia Caroya",
                      text: "Colonia Caroya",
                      value: "Colonia Caroya",
                    },
                  ]}
                ></Form.Dropdown>
              </Form.Field>

              <div>
                <Form.Button
                  style={estiloBotones.Siguiente}
                  type="submit"
                  fluid
                  size="large"
                  loading={formik.isSubmitting}
                >
                  {continuar}
                </Form.Button>
              </div>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {/* )} */}
    </div>
  );
}
